import { defineStore } from 'pinia';
import { api } from '../boot/axios'

export const useEmployerStore = defineStore('employer', {
  persist: true,

  state: () => ({
    employers: [],
    employersLoading: false
  }),

  getters: {
    getEmployers: (state) => (clientID) => {
      return state.employers.filter(employer => employer.clientID === clientID)
    },
  },

  actions: {
    saveEmployerLocally (employer) {
      let present = false
      if (this.employers) {
        for (let i = 0; i < this.employers.length; i++) {
          if (this.employers[i].employerID === employer.employerID) {
            Object.assign(this.employers[i], employer)
            present = true
            break
          }
        }
      }
      if (!present) {
        this.employers.push(employer)
      }
    },
    async fetchEmployers (clientID) {
      // commit(EMPLOYERS_GET_EMPLOYERS_PENDING)
      this.employersLoading = true
      api
        .get('api/v1/employers/client/' + clientID)
        .then(response => {
          response.data.forEach(employer => {
            // commit(EMPLOYERS_GET_EMPLOYER_SUCCESS, employer)
            this.saveEmployerLocally(employer)
          })
          // commit(EMPLOYERS_GET_EMPLOYERS_SUCCESS)
          this.employersLoading = false
        })
        .catch(err => {
          console.error(err)
        })
    },
    postEmployer (employer) {
      return new Promise((resolve, reject) => {
        api
          .post('api/v1/employers', employer)
          .then(response => {
            // commit(EMPLOYERS_GET_EMPLOYER_SUCCESS, response.data)
            this.saveEmployerLocally(response.data)
            resolve(response.data)
          })
          .catch(err => {
            console.error(err)
            reject(err)
          })
      })
    }
  }

})
